import type { SxProps, Theme } from '@mui/material'

export const header_shadow: SxProps<Theme> = (theme) => ({
  boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.4)',
  ...theme.applyStyles('dark', { boxShadow: 'none' }),
})

export const upload_error = Object.freeze({
  storage_over: Symbol('storage_over'),
  size_upper: Symbol('size_upper'),
  size_lower: Symbol('size_lower'),
  file_format: Symbol('file_format'),
  file_break: Symbol('file_break'),
  file_count_over: Symbol('file_count_over'),
  other: Symbol('other'),
} as const)

export type UploadResult = typeof upload_error[keyof typeof upload_error] | undefined
export type UploadStates = {files: File[], results: UploadResult[]}
export type UploadResults = {file: File, result: UploadResult}[]
export type UploadErrorResults = {file: File, result: Exclude<UploadResult, undefined>}[]